// ErrorFallback.jsx

import {
  Button,
  Image,
  Row,
  Typography,
  Space,
} from "../../common/utils/antd-imports/AntdImports";
import ErrorImg from "../../../assests/images/Error-image.png";
// import "./NotFoundPage.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NavBar from "../../layout/navbar/NavBar";
export default function ErrorFallback({ error, resetErrorBoundary }) {
  const { Text } = Typography;
  const userRole = useSelector((state) => state.login.userType);
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate("/home");
  };
  return (
    <>
      <div>
        <NavBar />
      </div>

      <div className="not-found-page-container">
        <div className="main">
          <Row>
            <Image
              src={ErrorImg}
              preview={false}
              alt="Error"
              width={500}
              height={300}
            />
          </Row>
          <Row className="oops-page-text-header-row">
            <Text className="oops-page-text-header">Something went wrong!</Text>
          </Row>
          <Row className="page-not-found-paragraph-row">
            <Text className="page-not-found-paragraph-text">
              We’re sorry, but something went wrong. — you’re still in AMP!
            </Text>
          </Row>
          <Row className="go-back-page-not-button">
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                className="signup-button billboard-button-2"
                onClick={handleGoBack}
              >
                Go to Home
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="signup-button billboard-button-2"
                onClick={() => navigate(-1)}
              >
                Previous Page
              </Button>
            </Space>
          </Row>
        </div>
      </div>
    </>
  );
}
